module.exports = __webpack_public_path__ + "8ca4bae62fb88010dd51f8639de71c9f.jpg";